import { TAG_STATUS } from '@evinced-private/ui-common';

import type { TREND_TAG_KIND } from './constants';

// Tag interfaces for better type safety
export interface StatusTag {
	status: TAG_STATUS;
	text: string;
}

export type TrendTag =
	| { kind: typeof TREND_TAG_KIND.INFO; text: string }
	| { kind: typeof TREND_TAG_KIND.LIFT; liftNumber: number; success: boolean };

// Enums for better type safety
export enum AccessibilityStatus {
	POOR = 'poor',
	MODERATE = 'moderate',
	GOOD = 'good',
	EXCELLENT = 'excellent'
}

export enum TrendDirection {
	UP = 'up',
	DOWN = 'down'
}
